import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { element } from 'protractor';
import { MortgageService } from '../mortgage.service';


export interface Option {
  value: string;
  viewValue: string;
}

export interface OptionGroup {
  disabled?: boolean;
  name: string;
  option: Option[];
}

@Component({
  selector: 'app-search-insurance',
  templateUrl: './search-insurance.component.html',
  styleUrls: ['./search-insurance.component.css']
})
export class SearchInsuranceComponent implements OnInit {
  matDialogReference: any;
  hideThisDiv = true;
  searcchData: any;
  healthData: any = [];
  seachApiData: any;
  heathID: any;
  subData: any;
  searcchDataval: any = [];
  searchProduct: any = [];
  PolicyType: any = [];
  RidersAvailable: any = [];
  Underwriting: any = [];
  subDataResponse: any = [];
  question_id: any = [];
  finaldata: any;
  AnswerData: any;
  AnswerData1: any[] = [];
  questiondataRes: any[];
  healthDatanew = [];
  DataFlag: boolean = false;
  newquestion_id: any;
  Finaldta: any = [];
  answeResponse: any = [];
  optionControl = new FormControl();
  public subCategories: any = [];
  healthCatId: any;
  loader: boolean = false;
  visible: boolean = false;
  healthSub: any;

  constructor(public dialog: MatDialog, public data: MortgageService,) { }

  ngOnInit() {
    this.data.searchInsuranceVm().subscribe(res => {
      let obj = JSON.parse(res.message);
      this.searcchData = obj.results;
      this.searcchData.forEach(element => {
        this.searcchDataval = element;
        if (this.searcchDataval.type == 1) {
          this.searchProduct.push(element);
        }
        if (this.searcchDataval.type == 2) {
          this.PolicyType.push(element);
        }
        if (this.searcchDataval.type == 3) {
          this.RidersAvailable.push(element)
        }
        if (this.searcchDataval.type == 4) {
          this.Underwriting.push(element);
        }
      });
    })
    this.data.healthcatagory().subscribe(res => {
      let obj = JSON.parse(res.message);
      this.healthData = obj.results;
    })
  }
  onChange(id: any, selected: boolean) {
    this.heathID = id;
    if (selected == true) {
      let isHealthCatAdd = true;
      if (this.heathID && isHealthCatAdd) {
        this.loader = true;
        this.data.healthsubcatagory(this.heathID).subscribe(res => {
          this.subCategories.push(JSON.parse(res.message));
          this.subCategories.forEach(ele => {
            ele.answer.forEach(ans => {
              this.data.healthsubcatagory(ans.question_id).subscribe(res => {
                if (res != null) {
                  let obj = JSON.parse(res.message);
                  ans.AnswerData = obj.answer;
                }
                if (ans.AnswerData != undefined) {
                  ans.AnswerData.forEach(answer => {
                    this.data.healthsubcatagory(answer.question_id).subscribe(res => {
                      this.loader = false;
                      let obj = JSON.parse(res.message);
                      answer.answeResponse = obj.answer;
                      this.healthSub = answer.answeResponse;
                    })
                  })
                }
              })
            })
          })
        })
      }
    }
    else {
      $('.questionSetNo_' + this.heathID).remove();
    }
  }
  onSearch() {
    this.loader = true;
    // this.DataFlag = true 
    this.data.SearchAPI(this.heathID).subscribe(res => {
      this.loader = false;
      let obj = JSON.parse(res.message);
      this.healthDatanew = obj.result;
      if (this.healthDatanew.length > 0) {
        this.Finaldta = this.healthDatanew;
      }
      this.visible = true;
    })
  }

  Reset() {
    this.subCategories = [];
    this.healthData = [];
    this.searchProduct = [];
    this.PolicyType = [];
    this.RidersAvailable = [];
    this.Underwriting = [];
    this.Finaldta = [];
    this.healthSub = [];
    this.visible = false;
    if (this.healthData.length == 0 && this.searchProduct.length == 0 && this.PolicyType.length == 0 && this.RidersAvailable.length == 0 && this.Underwriting.length == 0 && this.Finaldta.length == 0 && this.healthSub.length == 0 && this.subCategories.length == 0) {
      this.ngOnInit();  
    }


  }

}
